import * as React from 'react';
import { Button, Checkbox, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import Paginator from 'components/common/paginator';
import { NextOrPrev, Pagination } from 'library/Types';
import useIsMobile from 'hooks/useIsMobile';
import { addressFieldStyles } from './address-field.styles';

interface ToolbarProps extends StylesProps<typeof addressFieldStyles> {
    currentAddressType: string;
    billToSame: boolean;
    onBillToSameChange: (checked: boolean) => void;
    onSearch: (value: string) => void;
    showSelectDefault: boolean;
    onSelectDefault: () => void;
    pagination: Pagination;
    onPaginationChange: (nextOrPrev: NextOrPrev) => void;
    onAddNew: () => void;
    disabled?: boolean;
}

const ToolbarComponent = (props: ToolbarProps) => {
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const {
        classes,
        currentAddressType,
        billToSame,
        onBillToSameChange,
        onSearch,
        showSelectDefault,
        onSelectDefault,
        pagination,
        onPaginationChange,
        onAddNew,
        disabled,
    } = props;

    return (
        <div className={classes.toolbar}>
            <Input
                placeholder={t('search_for_addresses')}
                type="search"
                onChange={(e) => onSearch(e.target.value)}
                className={classes.searchInput}
                disabled={disabled}
            />
            {currentAddressType === 'billToDetails' ? (
                <Checkbox
                    checked={billToSame}
                    onChange={(e) => onBillToSameChange(e.target.checked)}
                    style={{ marginRight: 'auto' }}
                    disabled={disabled}
                >
                    {t('use_same_as_delivery_address')}
                </Checkbox>
            ) : null}
            {showSelectDefault ? (
                <Button type="link" onClick={onSelectDefault} disabled={disabled}>
                    {t('select_default_address')}
                </Button>
            ) : null}
            {!isMobile && (
                <Paginator
                    currentPageNumber={pagination?.currentPageNumber}
                    isNextPresent={pagination?.isNextPresent}
                    onNextClick={() => onPaginationChange('next')}
                    onPrevClick={() => onPaginationChange('prev')}
                    onFirstClick={() => onPaginationChange('first')}
                />
            )}
            <Button
                type="primary"
                style={{ marginLeft: isMobile ? 4 : 0 }}
                onClick={onAddNew}
                disabled={disabled}
            >
                <PlusOutlined />
                {!isMobile && t('add_address')}
            </Button>
        </div>
    );
};

const hocConfig: HocOptions = {
    connectJss: {
        useJss: true,
        styleSheet: addressFieldStyles,
    },
};

export default GenericHoc(hocConfig)(ToolbarComponent);
